import { IUserAwards } from '../../../../../../store/admin/roundFormatAwards/store';

import { getUserAwards } from './getUserAwards';

export const getUserAward = (
  userId: number,
  userAwards: IUserAwards,
  awardsToUpdate: IUserAwards,
  isAHoleLeaderboard?: boolean,
  hole?: number
) => {
  const allUserAward = getUserAwards(userId, userAwards, awardsToUpdate) || [];

  const isAValidHole = hole !== null && hole !== undefined;

  const userAward =
    isAHoleLeaderboard && isAValidHole
      ? allUserAward.find(
          award => award.hole !== null && award.hole !== undefined && award.hole === Number(hole)
        )
      : allUserAward[0];

  return userAward;
};
